import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SVG from "react-inlinesvg";
import * as S from './styles';
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import ModalDialog from "../../../../components/flat/ui/ModalDialog";
import {
  trackMgmInviteModalLinkCopied,
  trackMgmInviteModalWhatsAppShared,
  trackMgmInviteModalEmailShared,
} from '../../../../components/Mgm/trackMgmEvents';

const InviteModal = ({ isOpen, challenge, onClose }) => {
  const [copied, setCopied] = useState(false);
  const { user } = useSelector((state) => state.auth);

  if (!challenge) return null;

  const clientId = user?.client_id || 'seu-codigo';
  const referralLink = `${process.env.REACT_APP_GAMIFICATION_INVITE_URL}?utm_source=referral&utm_medium=mgm&utm_campaign=${clientId}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      trackMgmInviteModalLinkCopied({ clientId: user?.client_id });
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(`Conheça a Jusfy! Use meu link de indicação: ${referralLink}`);
    window.open(`https://wa.me/?text=${message}`, '_blank');
    trackMgmInviteModalWhatsAppShared({ clientId: user?.client_id });
  };

  const handleEmail = () => {
    const subject = encodeURIComponent('Convite para conhecer a Jusfy');
    const body = encodeURIComponent(`Olá!\n\nGostaria de te convidar para conhecer a Jusfy, uma plataforma incrível para advogados.\n\nUse meu link de indicação: ${referralLink}\n\nAbraços!`);
    window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
    trackMgmInviteModalEmailShared({ clientId: user?.client_id });
  };

  return (
    <ModalDialog open={isOpen} width="460px" onClose={onClose}>
      <S.ModalContent>
        <S.CloseIcon onClick={onClose}>
          <SVG src={toAbsoluteUrl("/media/flat/close.svg")} />
        </S.CloseIcon>

          <S.Body>
          <S.TextBlock>
            <S.MainTitle>
              Indique e ganhe
            </S.MainTitle>
            <S.Description>
              Indique a Jusfy e ganhe <S.HighlightText>10 créditos</S.HighlightText> para fazer suas consultas jurídicas.
            </S.Description>
            <S.Description>
              E some <S.HighlightText>{challenge.points} XP</S.HighlightText> no ranking a cada advogado que assinar pelo seu link.
            </S.Description>
          </S.TextBlock>

          <S.ShareSection>
            <S.ShareLabel>Compartilhe seu link pessoal</S.ShareLabel>
            <S.LinkContainer>
              <S.LinkInput value={referralLink} readOnly />
              <S.CopyButton onClick={handleCopy}>
                <ContentCopyIcon sx={{ fontSize: 18 }} />
                {copied ? 'Copiado!' : 'Copiar'}
              </S.CopyButton>
            </S.LinkContainer>

            <S.ShareFooter>
              <S.SocialButtons>
                <S.SocialButton onClick={handleWhatsApp} type="whatsapp" aria-label="Compartilhar no WhatsApp">
                  <WhatsAppIcon sx={{ fontSize: 20 }} />
                </S.SocialButton>
                <S.SocialButton onClick={handleEmail} type="email" aria-label="Compartilhar por email">
                  <EmailIcon sx={{ fontSize: 20 }} />
                </S.SocialButton>
              </S.SocialButtons>
            </S.ShareFooter>
          </S.ShareSection>
        </S.Body>
      </S.ModalContent>
    </ModalDialog>
  );
};

export default InviteModal;

